<template>
  <div class="page">
    <div class="head">
        入库审批
    </div>
    <div class="content">
        <div class="bar">
            <el-input style="width:10%" clearable v-model="query.keyword" placeholder="请输入学号">
                
            </el-input>
            <el-button  class="bartip"  @click="toSearch" size="small" type="primary" round>搜索</el-button>
        </div>
        <div class="table" >
            <el-table
                :data="tableData"
                stripe
                style="width: 100%">
                <el-table-column
                type="index"
                label="序号"
                width="60"
                :index="indexMethod"
                align="center"
                />
                <el-table-column
                    prop="code"
                    label="学号">
                </el-table-column>
                <el-table-column
                    prop="displayName"
                    label="姓名">
                </el-table-column>
                <el-table-column
                    prop="batchName"
                    label="入学批次">
                </el-table-column>
                <el-table-column
                    prop="courseName"
                    label="案例名称">
                </el-table-column>
                <el-table-column
                    prop="applicantName"
                    label="申请人">
                </el-table-column>
                <el-table-column
                    prop="auditName"
                    label="审批人">
                </el-table-column>
                <el-table-column
                    prop="status"
                    label="状态">
                    <template slot-scope="scope">

                        <el-tag v-if="scope.row.status === 'AGREE' "
                        type="success"
                        disable-transitions>已同意</el-tag>

                        <el-tag v-if="scope.row.status === 'DENY' "
                        type="danger"
                        disable-transitions>已拒绝</el-tag>

                        <el-tag v-if="scope.row.status === 'SUBMIT' "
                        type="primary"
                        disable-transitions>已提交</el-tag>
                        
                        <el-tag v-if="scope.row.status === 'AUDITING' "
                        type="warning"
                        disable-transitions>审批中</el-tag>

                    </template>
                </el-table-column>
                 <el-table-column
                    prop="applyAt"
                    label="申请时间">
                </el-table-column>
                <el-table-column
                    prop="auditAt"
                    label="审批时间">
                </el-table-column>
                
                 <el-table-column label="操作">
                    <template #default="record">
                        <el-link :underline="false" @click.prevent="preview(record.row)" type="primary">查看报告</el-link>
                        <el-link :underline="false" @click.prevent="approval(record.row)" type="primary">审批</el-link>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <!-- 分页 -->
            <el-pagination
            @current-change="handleCurrentChange"
            :current-page="query.currentPage"
            :page-size="query.size"
            layout="total, prev, pager, next, jumper"
            :total="query.total"
            />
        
        <!-- 审批 -->

          <el-dialog :title="title2" :visible.sync="visible2" @close="dialogCloseHandler2">
        
            <el-radio v-model="audit.status" label="AGREE">通过</el-radio>
            <el-radio v-model="audit.status" label="DENY">不通过</el-radio>

             <div slot="footer" class="dialog-footer">
                <el-button type="primary" size="small" @click="submitHandler2">确 定</el-button>
            </div>
          </el-dialog>

       <!--  <el-dialog :title="title2" :visible.sync="visible2" @close="dialogCloseHandler2" width=70% center>

            <div class="shenpi_content">
              <div class="information">
                <el-row>
                  <el-col :span="3" :offset="1">姓名：XX<div class="grid-content bg-purple"></div></el-col>
                  <el-col :span="3">学号：XX<div class="grid-content bg-purple-light"></div></el-col>
                  <el-col :span="3">站点：XX<div class="grid-content bg-purple-light"></div></el-col>
                  <el-col :span="4" :offset="6">实际得分：XX (通过)<div class="grid-content bg-purple-light"></div></el-col>
                </el-row>
              </div>
              <div class="task">
                <el-row>
                  <el-col :span="6">1.收获与体会不合格<div class="grid-content"></div></el-col>
                  <el-col :span="3" :offset="5">满分：7<div class="grid-content"></div></el-col>
                  <el-col :span="3">得分：7<div class="grid-content"></div></el-col>
                </el-row>
              </div>
              <div class="task_pjbz">
                <ul>
                  <li>评价标准：</li>
                  <li>可根据内容相关度等内容，在0-7分间给出得分；</li>
                  <li>所提交的收获总结及心得体会与本次实训内容无关的不得分。若相关则酌情给分</li>
                </ul>
              </div>
              <div class="task_content">
                <div class="content_title">学生实践报告内容（300字左右）</div>
                <div class="content_main">内容</div>
              </div>
              <div class="task">
                <el-row>
                  <el-col :span="6">2.特征工程不合格<div class="grid-content"></div></el-col>
                  <el-col :span="3" :offset="5">满分：1<div class="grid-content"></div></el-col>
                  <el-col :span="3">得分：1<div class="grid-content"></div></el-col>
                </el-row>
              </div>
              <div class="task_pjbz">
                <ul>
                  <li>评价标准：</li>
                  <li>找到的相关特征列中包含在以下列中的少于3个高相关的不得分状态、套餐名称、流量、通话时长、出账收入、最近停机时间</li>
                </ul>
              </div>
              <div class="task_content">
                <div class="content_main">该学生找到X个高相关的特征项</div>
              </div>
              <div class="task">
                <el-row>
                  <el-col :span="6">3.数据拆分不合格<div class="grid-content"></div></el-col>
                  <el-col :span="3" :offset="5">满分：1<div class="grid-content"></div></el-col>
                  <el-col :span="3">得分：1<div class="grid-content"></div></el-col>
                </el-row>
              </div>
              <div class="task_pjbz">
                <ul>
                  <li>评价标准：</li>
                  <li>填写训练集低于60%高于90%的不得分</li>
                </ul>
              </div>
              <div class="task_content">
                <div class="content_main">该学生训练集为X%</div>
              </div>
              <div class="task">
                <el-row>
                  <el-col :span="6">4.模型精度不合格<div class="grid-content"></div></el-col>
                  <el-col :span="3" :offset="5">满分：1<div class="grid-content"></div></el-col>
                  <el-col :span="3">得分：1<div class="grid-content"></div></el-col>
                </el-row>
              </div>
              <div class="task_pjbz">
                <ul>
                  <li>评价标准：</li>
                  <li>模型准确度大于等于65%则得分，低于65%的不得分。</li>
                </ul>
              </div>
              <div class="task_content">
                <div class="content_titleb">构建模型错误，模型的准确度太低，无法识别出低价值用户</div>
              </div>
              <div class="task">
                <el-row>
                  <el-col :span="6">5.数据预处理不合格<div class="grid-content"></div></el-col>
                  <el-col :span="3" :offset="5">满分：1<div class="grid-content"></div></el-col>
                  <el-col :span="3">得分：1<div class="grid-content"></div></el-col>
                </el-row>
              </div>
              <div class="task_pjbz">
                <ul>
                  <li>评价标准：</li>
                  <li>汇总表数据行数大于等于6万行且删除了“性别”列则得分；否则不得分。</li>
                </ul>
              </div>
              <div class="task_content">
                <div class="content_main">1、数据预处理方式错误，删除了大量数据，导致剩余数据无法构建出正确的大数据决策模型</div>
                <div class="content_main">2、数据处理方式错误，导致数据中依然存在大量的异常数据</div>
              </div>
              <div class="task">
                <el-row>
                  <el-col :span="6">6.数据探索不合格<div class="grid-content"></div></el-col>
                  <el-col :span="3" :offset="5">满分：0<div class="grid-content"></div></el-col>
                  <el-col :span="3">得分：0<div class="grid-content"></div></el-col>
                </el-row>
              </div>
              <div class="task_pjbz">
                <ul>
                  <li>评价标准：</li>
                  <li>未指明，仅参考</li>
                </ul>
              </div>
              <div class="task_content">
                <div class="content_main">数据探索的结果错误，没有探索出正确的异常数据</div>
              </div>
              <div class="task">
                <el-row>
                  <el-col :span="6">老师评语<div class="grid-content"></div></el-col>
                </el-row>
              </div>
              <div>
                 <el-input
                  type="textarea"
                  :autosize="{ minRows: 6, maxRows: 500}"
                  placeholder="请输入评语"
                  v-model="pingyu"
                  maxlength="1000"
                  show-word-limit
                  >
                </el-input>
              </div>
            </div> -->
            <!-- <el-radio v-model="audit.status" label="AGREE">通过</el-radio>
            <el-radio v-model="audit.status" label="DENY">不通过</el-radio> -->
           <!--  <div slot="footer" class="dialog-footer">
            
                <el-button type="primary" size="small" >提交，并申请为优秀报告</el-button>
                <el-button type="primary" size="small" @click="submitHandler2">确 定</el-button>
            </div>
        </el-dialog> -->
    </div>
    <el-drawer

    title="预览实践报告"
    
    :visible.sync="dialogVisible1"
    :direction="direction"
    size="100%"
    :with-header="true">
    <div class="download">
    </div>
    <!-- <iframe class="prism-player" :src="pdfUrl" width="100%" height="100%"></iframe> -->
    <div class="sjbg_fg"></div>
    <div class="sjbg_bg">
        <el-row>
        <el-col :span="6"></el-col>
        <el-col :span="12">
            
        </el-col>
        <el-col :span="6"></el-col>
        </el-row>
        <div class="sjbg_table">
        <div class="sjbg_title">
            <ul>
            <li>《大数据决策》—{{report.courseName}}</li>
            <li>实践报告</li>
            </ul>
        </div>
        <div class="sjbg">
            <div class="title">一、学生基本信息</div>
            <div class="first">
            <el-row>
                <el-col :span="3"><div class="table_cell_left" style="margin-left:-4px" >姓名</div></el-col>
                <el-col :span="5"><div class="table_cell">{{report.displayName}}</div></el-col>
                <el-col :span="3"><div class="table_cell">学号</div></el-col>
                <el-col :span="5"><div class="table_cell">{{report.code}}</div></el-col>
                <el-col :span="3"><div class="table_cell">入学批次</div></el-col>
                <el-col :span="5"><div class="table_cell">{{report.enrollBatch}}</div></el-col>
            </el-row>
            </div>
            <div class="first">
            <el-row >
                <el-col :span="3"><div class="table_cell_left" style="margin-left:-2px" >专业</div></el-col>
                <el-col :span="5"><div class="table_cell">{{report.major}}</div></el-col>
                <el-col :span="3"><div class="table_cell">层次</div></el-col>
                <el-col :span="5"><div class="table_cell">{{report.level}}</div></el-col>
                <el-col :span="3"><div class="table_cell">校外站点</div></el-col>
                <el-col :span="5"><div class="table_cell">{{report.site}}</div></el-col>
            </el-row>
            </div>
            <div class="first">
            <el-row>
                <el-col :span="3"><div class="table_cell_left" style="margin-left:-2px" ><span>报告起</span><br><span>止时间</span></div></el-col>
                <el-col :span="8"><div class="table_cell">{{report.start}}至<br>{{report.end}}</div></el-col>
                <el-col :span="5"><div class="table_cell"><span>实践报告</span><br><span>评定结果</span></div></el-col>
                <el-col :span="8"><div class="table_cell">{{report.result}}</div></el-col>
            </el-row>
            </div>
            <div class="title2">二、实践目的</div>
            <div class="paragraph_table">1.	了解数据科学基础知识，初步具备大数据决策思维。</div>
            <div class="paragraph_table">2.	熟悉大数据决策基本步骤，对提供的真实案例在实训系统辅助下自主完成大数据处理和决策的主要环节，掌握阅读大数据决策报告的基本要点和方法。</div>
            <div class="paragraph_last">3.	初步具备运用大数据决策方法和思路，决策和解决实际业务问题的素质和能力。</div>
            <div class="title3">三、实践要求</div>
            <div class="paragraph_table">1.	在系统中按照实践报告步骤完成指定的操作及习题等过程任务。</div>
            <div class="paragraph_table">2.	结合大数据决策实训过程，完成实践报告总结和心得体会的撰写，形成完整的实践报告。（300-1000字）</div>
            <div class="paragraph_last">3.	实践报告评定结果为“通过”或“不通过”。</div>
            <div class="title3">四、案例简介</div>
            <div class="paragraph_last">2016年1月末，某通信集团河北分公司通过总部下发的2015年09月到12月本区域的月度决策报表，发现近期开展的推广活动业务营收与推广用户的增长与预期收益相差甚远。请以分公司区域经理的身份，基于真实数据，在大数据决策实训系统的辅助下，找出问题原因，并给出解决方案。</div>
            <div class="title">五、实践内容</div>
        <!--  <div class="paragraph_heading">关于“{{report.courseName}}”的实践报告</div> -->
            <div class="paragraph">本次《大数据决策实践报告》基于实训系统中的“{{report.courseName}}”案例，运用大数据决策方法，在系统引导下通过准备数据、大数据分析、决策应用三个阶段任务，寻找数据内在规律，建立可行的大数据决策模型，从分公司区域经理角度给出了针对案例中“酬金倒挂”现象的解决方案。</div>
            <div class="paragraph_title">一、实训记录</div>
            <div class="paragraph_title">遵循数据建模的一般流程，本次实训过程具体如下：</div>
            <div class="paragraph_title2">1.	数据采集</div>
            <div class="paragraph">本次实训选取“渠道及推广人表”、“推广人发展用户表”、“佣金结算表”、“用户基本信息表”、“用户套餐表”、“用户状态”、“费用表”，合并为汇总数据，完成了数据采集，具体如下：</div>
            <div class="paragraph_heading2">汇总数据量统计表</div>
            <div class="second">
            <el-row>
                <el-col :span="8"><div class="table_cell2">表格名称</div></el-col>
                <el-col :span="8"><div class="table_cell2">列数量</div></el-col>
                <el-col :span="8"><div class="table_cell2_right">行数量</div></el-col>
            </el-row>
            <el-row>
                <el-col :span="8"><div class="table_cell2">渠道及推广人表</div></el-col>
                <el-col :span="8"><div class="table_cell2">4</div></el-col>
                <el-col :span="8"><div class="table_cell2_right">150</div></el-col>
            </el-row>
            <el-row>
                <el-col :span="8"><div class="table_cell2">推广人发展用户表</div></el-col>
                <el-col :span="8"><div class="table_cell2">5</div></el-col>
                <el-col :span="8"><div class="table_cell2_right">37828</div></el-col>
            </el-row>
            <el-row>
                <el-col :span="8"><div class="table_cell2">佣金结算表</div></el-col>
                <el-col :span="8"><div class="table_cell2">6</div></el-col>
                <el-col :span="8"><div class="table_cell2_right">88540</div></el-col>
            </el-row>
            <el-row>
                <el-col :span="8"><div class="table_cell2">用户基本信息表</div></el-col>
                <el-col :span="8"><div class="table_cell2">7</div></el-col>
                <el-col :span="8"><div class="table_cell2_right">37829</div></el-col>
            </el-row>
            <el-row>
                <el-col :span="8"><div class="table_cell2">用户套餐表</div></el-col>
                <el-col :span="8"><div class="table_cell2">5</div></el-col>
                <el-col :span="8"><div class="table_cell2_right">37828</div></el-col>
            </el-row>
            <el-row>
                <el-col :span="8"><div class="table_cell2">用户状态</div></el-col>
                <el-col :span="8"><div class="table_cell2">7</div></el-col>
                <el-col :span="8"><div class="table_cell2_right">88540</div></el-col>
            </el-row>
            <el-row>
                <el-col :span="8"><div class="table_cell2">费用表</div></el-col>
                <el-col :span="8"><div class="table_cell2">9</div></el-col>
                <el-col :span="8"><div class="table_cell2_right">88540</div></el-col>
            </el-row>
            <el-row style="border-bottom: 2px solid #2d3e50;">
                <el-col :span="8"><div class="table_cell2">合计</div></el-col>
                <el-col :span="8"><div class="table_cell2">43</div></el-col>
                <el-col :span="8"><div class="table_cell2_right">379255</div></el-col>
            </el-row>
            </div>
            <div class="paragraph_title2">2.	数据探索</div>
            <div class="paragraph">通过观察，汇总后数据共23列、88571条记录。数据存在缺失、重复、异常等问题，需处理后决策。具体结果如下：</div>
            <div class="third">
            <el-row>
                <el-col :span="7"><div class="table_cell3">使用工具</div></el-col>
                <el-col :span="17"><div class="table_cell3_right">决策结果</div></el-col>
            </el-row>
            <el-row>
                <el-col :span="7"><div class="table_cell3">缺失值探索工具</div></el-col>
                <el-col :span="17"><div class="table_cell3_right2">“地市”、“性别”数据存在缺失。其中{{report.maxMissingValue}}的缺失值很多，{{report.minMissingValue}}缺失值少。</div></el-col>
            </el-row>
            <el-row style="border-bottom: 2px solid #2d3e50;">
                <el-col :span="7"><div class="table_cell3">数据分布探索工具</div></el-col>
                <el-col :span="17"><div class="table_cell3_right2">{{report.negativeColumn}}存在一些负值。</div></el-col>
            </el-row>
            </div>
            <div class="paragraph_title2">3.	数据预处理</div>
            <div class="paragraph">针对数据探索中发现的缺失值、重复、和异常值等数据的处理如下：</div>
            <div class="paragraph" style="padding-top:10px;padding-bottom:10px">{{report.processResult}}</div>
            <div class="fourth">
            <el-row>
                <el-col :span="10"><div class="table_cell4">数据处理类型</div></el-col>
                <el-col :span="14"><div class="table_cell4_right">删除数量</div></el-col>
            </el-row>
            <el-row>
                <el-col :span="10"><div class="table_cell4">缺失值</div></el-col>
                <el-col :span="14"><div class="table_cell4_right2">{{report.cell11}}</div></el-col>
            </el-row>
            <el-row>
                <el-col :span="10"><div class="table_cell4">重复值</div></el-col>
                <el-col :span="14"><div class="table_cell4_right2">{{report.cell21}}</div></el-col>
            </el-row>
            <el-row>
                <el-col :span="10"><div class="table_cell4">异常值</div></el-col>
                <el-col :span="14"><div class="table_cell4_right2">{{report.cell31}}</div></el-col>
            </el-row>
            <el-row style="border-bottom: 2px solid #2d3e50;">
                <el-col :span="10"><div class="table_cell4">合计</div></el-col>
                <el-col :span="14"><div class="table_cell4_right2">{{report.cell41}}</div></el-col>
            </el-row>
            </div>
            <div class="paragraph_title2">4.	数据分析</div>
            <div class="paragraph">{{report.featureResult}}</div>
            <div class="paragraph_title2">5.	数据拆分</div>
            <div class="paragraph">根据大数据决策建模方法，本次将汇总数据的{{report.trainSize}}%作为训练集，用于训练模型；{{report.testSize}}%作为测试集，用于模型的评估。</div>
            <div class="paragraph_title2">6.	大数据分析→算法选取→模型评估</div>
            <div class="paragraph">经过反复调整、不断完善，本次实训共进行了{{report.modelTimes}}次尝试，最终我选定“{{report.algorithm}}”方法进行构建模型，得到了“{{report.courseName}}”模型。通过模型评估，得到模型的准确率为{{report.accuracy}}。</div>
            <div class="fifth">
            <el-row>
                <el-col :span="8"><div class="table_cell5">使用模型</div></el-col>
                <el-col :span="8"><div class="table_cell5">使用数据</div></el-col>
                <el-col :span="8"><div class="table_cell5_right">预测准确率</div></el-col>
            </el-row>
            <el-row style="border-bottom: 2px solid #2d3e50;">
                <el-col :span="8"><div class="table_cell5">{{report.modelName}}</div></el-col>
                <el-col :span="8"><div class="table_cell5">{{report.dataName}}</div></el-col>
                <el-col :span="8"><div class="table_cell5_right2">{{report.accuracy}}</div></el-col>
            </el-row>
            </div>
            <div class="paragraph_title2" style="padding-top:10px">7.	决策应用</div>
            <div class="paragraph">将2月份数据输入模型，历时{{report.spendTime}}秒得到2月份的低价值用户{{report.lowValueNum}}名，定位到对应的恶意推广人{{report.promoterNum}}人。经调研确认后，取消其佣金发放，为分公司避免了{{report.money}}%的酬金支出成本。</div>
            <div class="paragraph_title">二、收获与体会</div>
            <div class="paragraph" style="padding-top:10px;word-break: break-all;" v-html="report.subjectiveContent"></div>
        <!--  <div class="paragraph" style="padding-top:10px">我理解了人工智能的基本原理，掌握了人工智能的建模流程，学习到了人工智能的基本知识；</div>
            <div class="paragraph" style="padding-top:10px">同时，我也深刻体会到大数据时代，大数据技术给我们的工作和生活带来的便捷</div> -->

        </div>
        </div>
    </div>
    </el-drawer>
    <el-drawer


  title="预览实践报告"
  
  :visible.sync="dialogVisible2"
  :direction="direction"
  size="100%"
  :with-header="true"
  >

<!--   <div v-for="(question,index) in questions" :key="index" :index="index" >
     <div>{{question.content}}</div>
     <el-radio-group v-model="answer2" v-if="question.type='SINGLE_CHOICE'" >
          <el-radio :label="toABC(index)" v-for="option,index in questions[2].answers" :key="toABC(index)" class="ques">{{toABC(index)}}.{{option.content}}</el-radio>
      </el-radio-group>
    
  </div> -->

<!--   <div class="download">
    <el-button type="primary" size="mini" icon="el-icon-download" @click="download">下载报告</el-button>
  </div> -->
  <!-- <iframe class="prism-player" :src="pdfUrl" width="100%" height="100%"></iframe> -->
  <div class="sjbg_fg"></div>
  <div class="sjbg_bg">
    <el-row>
      <el-col :span="6"></el-col>
      <el-col :span="12">
        
      </el-col>
      <el-col :span="6"></el-col>
    </el-row>
    <div class="sjbg_table">
      <div class="sjbg_title">
        <ul>
          <li>《大数据决策》—{{report.courseName}}</li>
          <li>实践报告</li>
        </ul>
      </div>
      <div class="sjbg">
        <div class="title">一、学生基本信息</div>
        <div class="first">
          <el-row>
            <el-col :span="3"><div class="table_cell_left" style="margin-left:-4px" >姓名</div></el-col>
            <el-col :span="5"><div class="table_cell">{{report.displayName}}</div></el-col>
            <el-col :span="3"><div class="table_cell">学号</div></el-col>
            <el-col :span="5"><div class="table_cell">{{report.code}}</div></el-col>
            <el-col :span="3"><div class="table_cell">入学批次</div></el-col>
            <el-col :span="5"><div class="table_cell">{{report.enrollBatch}}</div></el-col>
          </el-row>
        </div>
        <div class="first">
          <el-row >
            <el-col :span="3"><div class="table_cell_left" style="margin-left:-2px" >专业</div></el-col>
            <el-col :span="5"><div class="table_cell">{{report.major}}</div></el-col>
            <el-col :span="3"><div class="table_cell">层次</div></el-col>
            <el-col :span="5"><div class="table_cell">{{report.level}}</div></el-col>
            <el-col :span="3"><div class="table_cell">校外站点</div></el-col>
            <el-col :span="5"><div class="table_cell">{{report.site}}</div></el-col>
          </el-row>
        </div>
        <div class="first">
          <el-row>
            <el-col :span="3"><div class="table_cell_left" style="margin-left:-2px" ><span>报告起</span><br><span>止时间</span></div></el-col>
            <el-col :span="8"><div class="table_cell">{{report.start}}至<br>{{report.end}}</div></el-col>
            <el-col :span="5"><div class="table_cell"><span>实践报告</span><br><span>评定结果</span></div></el-col>
            <el-col :span="8"><div class="table_cell">{{report.result}}</div></el-col>
          </el-row>
        </div>
        <div class="title2">二、实训目的</div>
        <div class="paragraph_table">1.	了解数据科学基础知识，初步具备大数据决策思维。</div>
        <div class="paragraph_table">2.	熟悉大数据决策基本步骤，对提供的真实案例在实训系统辅助下自主完成大数据处理和决策的主要环节，掌握阅读大数据决策报告的基本要点和方法。</div>
        <div class="paragraph_last">3.	初步具备运用大数据决策方法和思路，决策和解决实际业务问题的素质和能力。</div>
        <div class="title3">三、案例简介</div>
        <div class="paragraph">截止2019年底，某电商平台积累了近五年的经营数据，同时使用用户已达近10万个，商品近1万种。现发现平台上已注册用户的复购率较低，电商平台希望借助个性化推荐的功能，向用户推荐他们感兴趣的商品，从而促成购买过程，达到提升复购率的目的。</div>
        <div class="paragraph">请你作为平台的数据分析人员，帮助电商平台达到提升复购率的目的。</div>
        <div class="paragraph_last"></div>
        <div class="title">四、实践内容</div>
        <div class="paragraph_heading">关于“{{report.courseName}}”的实践报告</div>
        <div class="paragraph">本次《大数据决策实践报告》基于实训系统中的“{{report.courseName}}”案例，运用大数据决策方法，在系统引导下通过准备数据、大数据分析、决策应用三个阶段任务，寻找数据内在规律，建立可行的大数据决策模型，从数据分析人员的角度给出了针对案例中“复购率低”的解决方案。</div>
        <div class="paragraph_title">一、实训记录</div>
        <div class="paragraph_title">遵循数据建模的一般流程，本次实训过程具体如下：</div>
        <div class="paragraph_title2">1.	数据采集</div>
        <div class="paragraph">本次实训选取“分享”、“商品售价”、“商品名称”、“进入下单页”、“商品类别”、“少描述”、“商品标价”、 “收藏”、“评分”、“支付”、“点击详情”、“性别”、“职业”、“年龄”、“商品品牌”等采集点，分别合成数据表，完成数据采集，具体如下：</div>
        <div class="paragraph_heading2">汇总数据量统计表</div>
        <div class="second">
          <el-row>
            <el-col :span="8"><div class="table_cell2">表格名称</div></el-col>
            <el-col :span="8"><div class="table_cell2">列数量</div></el-col>
            <el-col :span="8"><div class="table_cell2_right">行数量</div></el-col>
          </el-row>
          <el-row>
            <el-col :span="8"><div class="table_cell2">用户行为数据表</div></el-col>
            <el-col :span="8"><div class="table_cell2">9</div></el-col>
            <el-col :span="8"><div class="table_cell2_right">100000</div></el-col>
          </el-row>
          <el-row>
            <el-col :span="8"><div class="table_cell2">用户属性数据表</div></el-col>
            <el-col :span="8"><div class="table_cell2">6</div></el-col>
            <el-col :span="8"><div class="table_cell2_right">10000</div></el-col>
          </el-row>
          <el-row>
            <el-col :span="8"><div class="table_cell2">商品数据表</div></el-col>
            <el-col :span="8"><div class="table_cell2">6</div></el-col>
            <el-col :span="8"><div class="table_cell2_right">500</div></el-col>
          </el-row>
          <el-row style="border-bottom: 2px solid #2d3e50;">
            <el-col :span="8"><div class="table_cell2">合计</div></el-col>
            <el-col :span="8"><div class="table_cell2">21</div></el-col>
            <el-col :span="8"><div class="table_cell2_right">110500</div></el-col>
          </el-row>
        </div>
        <div class="paragraph_title2">2.	数据探索</div>
        <div class="paragraph">通过观察，商品数据表共9列、10000条数据。这些数据存在缺失、重复、异常等问题，需处理后再决策。具体结果如下：</div>
        <div class="third">
          <el-row>
            <el-col :span="7"><div class="table_cell3">使用工具</div></el-col>
            <el-col :span="17"><div class="table_cell3_right">决策结果</div></el-col>
          </el-row>
          <el-row>
            <el-col :span="7"><div class="table_cell3">缺失值探索工具</div></el-col>
            <el-col :span="17"><div class="table_cell3_right2">{{report.missingValue}}数据存在缺失。其中{{report.maxMissingValue}}的缺失值很多，{{report.minMissingValue}}缺失值少</div></el-col>
          </el-row>
          <el-row style="border-bottom: 2px solid #2d3e50;">
            <el-col :span="7"><div class="table_cell3">数据分布探索工具</div></el-col>
            <el-col :span="17"><div class="table_cell3_right2">{{report.negativeColumn}}存在一些负值。</div></el-col>
          </el-row>
        </div>
        <div class="paragraph_title2">3.	数据预处理</div>
        <div class="paragraph">针对数据探索中发现的缺失值、重复、和异常值等数据的处理如下：</div>
        <div class="paragraph" style="padding-top:10px;padding-bottom:10px">{{report.processResult}}</div>
        <div class="fourthb">
          <el-row>
            <el-col :span="6"><div class="table_cell4b">数据处理类型</div></el-col>
            <el-col :span="6"><div class="table_cell4_rightb">替换行数</div></el-col>
            <el-col :span="6"><div class="table_cell4_rightb">删除行数</div></el-col>
            <el-col :span="6"><div class="table_cell4_right2b">删除列数</div></el-col>
          </el-row>
          <el-row>
            <el-col :span="6"><div class="table_cell4b">缺失值</div></el-col>
            <el-col :span="6"><div class="table_cell4_rightb">{{report.cell11}}</div></el-col>
            <el-col :span="6"><div class="table_cell4_rightb">{{report.cell12}}</div></el-col>
            <el-col :span="6"><div class="table_cell4_right2b">{{report.cell13}}</div></el-col>
          </el-row>
          <el-row>
            <el-col :span="6"><div class="table_cell4b">异常值</div></el-col>
            <el-col :span="6"><div class="table_cell4_rightb">{{report.cell21}}</div></el-col>
            <el-col :span="6"><div class="table_cell4_rightb">{{report.cell22}}</div></el-col>
            <el-col :span="6"><div class="table_cell4_right2b">{{report.cell23}}</div></el-col>
          </el-row>
          <el-row style="border-bottom: 2px solid #2d3e50;">
            <el-col :span="6"><div class="table_cell4b">合计</div></el-col>
            <el-col :span="12"><div class="table_cell4_rightb">{{report.cell31}}</div></el-col>
            <el-col :span="6"><div class="table_cell4_right2b">{{report.cell33}}</div></el-col>
          </el-row>
        </div>
        <div class="paragraph_title2">4.	数据分析</div>
        <div class="paragraph">构建了关注度分值新特征：</div>
        <div class="paragraph">依据电商公司内部确定的每个行为的关注度权重，将“进入下单页” 、“收藏” 、“分享” 、“点击详情” 、“支付” 、“评分”行为特征列，进行关注度分值新特征的构建。</div>
        <div class="paragraph">划分用户群体：</div>
        <div class="paragraph">经过观察“用户行为数据表”“用户属性数据表”“ 商品数据表”分析挖掘出用户群体，群体划分如下：</div>
        <div class="paragraph">大于等于16岁小于25岁的群体中任职学生的人数居多</div>
        <div class="paragraph">大于等于25岁小于35岁的群体中任职程序员的人数居多</div>
        <div class="paragraph">大于等于35岁小于60岁的群体中任职程序员的人数居多</div>
        <div class="paragraph">随后，分析挖掘人群对商品类别的关注度，得到这些人群对商品关注数据后，在推荐商品时针对不同的人群对商品进行推荐排序。</div>
        <div class="paragraph_title2">5.	数据拆分</div>
        <div class="paragraph">根据大数据决策建模方法，本次将汇总数据的{{report.trainSize}}%作为训练集，用于训练模型；{{report.testSize}}%作为测试集，用于模型的评估。</div>
        <div class="paragraph_title2">6.  方法选取→构建模型→规则评估</div>
        <div class="paragraph">经过反复调整、不断完善，本次实训共进行了{{report.modelTimes}}次尝试，最终我选定“{{report.algorithm}}”方法进行构建模型，得到了“{{report.courseName}}”模型。通过模型评估，得到模型的均方根误差为{{report.accuracy}}。</div>
        <div class="fifth">
          <el-row>
            <el-col :span="8"><div class="table_cell5">模型名称</div></el-col>
            <el-col :span="8"><div class="table_cell5">使用数据</div></el-col>
            <el-col :span="8"><div class="table_cell5_right">均方根误差</div></el-col>
          </el-row>
          <el-row style="border-bottom: 2px solid #2d3e50;">
            <el-col :span="8"><div class="table_cell5">{{report.modelName}}</div></el-col>
            <el-col :span="8"><div class="table_cell5">{{report.dataName}}</div></el-col>
            <el-col :span="8"><div class="table_cell5_right2">{{report.accuracy}}</div></el-col>
          </el-row>
        </div>
        <div class="paragraph_title2" style="padding-top:10px">7.	决策应用</div>
        <div class="paragraph">将数据输入电商推荐决策模型，历时{{report.spendTime}}秒得到了“对指定用户推荐商品”和“指定商品推荐给用户”的两个推荐结果。</div>
        <div class="paragraph">针对不同用户的不同需求，成功实现了平台的个性化推荐，整体提升了平台的复购率。</div>
        <div class="paragraph_title">二、收获与体会</div>
          <div class="paragraph" style="padding-top:10px;word-break: break-all;" v-html="report.subjectiveContent"></div>
        <!-- <div class="paragraph" style="padding-top:10px;word-break: break-all;" v-html="report.subjectiveContent"></div> -->
       <!--  <div class="paragraph" style="padding-top:10px">我理解了人工智能的基本原理，掌握了人工智能的建模流程，学习到了人工智能的基本知识；</div>
        <div class="paragraph" style="padding-top:10px">同时，我也深刻体会到大数据时代，大数据技术给我们的工作和生活带来的便捷</div> -->

      </div>
    </div>
  </div>
</el-drawer>
  </div>
</template>

<script>
import ajaxObj from "@/ajax";
export default {
    inject: ['reload'],
 data(){
     return {
        searchInput:'',
        tableData:[],
        query: {
            currentPage: 1,
            size: 10,
            page:0,
            total: 0,
            keyword:'',
        },
        // 添加 表单
        visible:false,
        visible2:false,
        title:'添加入库信息',
        title2:'修改入库信息',
        form: {},
        form2:{},
        rules: {

        },
        report:{

        },
        audit:{
            id:'',
            status:''
        },
        direction: 'ttb',
        dialogVisible1:false,
        dialogVisible2:false,
        pingyu:''
    }
 },
 methods:{
     preview(row){ 
        //this.dialogVisible1 =true;
        ajaxObj({url: "report/preview-by-report",method: "get",params:{
            reportId:row.reportId

        }})
        .then(response => {
            this.report = response.data.data;
        //     console.log(this.tableData);
        // this.query.total = response.data.meta.total;
        })
        if(row.courseName == '寻找通信行业低价值用户'){
          this.dialogVisible1 =true;
        } else if(row.courseName == '电商平台用户产品推荐'){
          this.dialogVisible2 =true;
        }
    },
     findUserlist(){
        ajaxObj({url: "excellent-report",method: "get"})
        .then(response => {
            this.tableData = response.data.data;
             this.query.total = response.data.meta.total;
            //console.log(this.tableData);
        })
     },
       // 序号
    indexMethod(index){
       index = index + 1 + (this.query.currentPage - 1) * this.query.size;
      return index;
    },
    //  搜索
     toSearch(){
        this.query.currentPage = 1;
        this.query.page = this.query.currentPage -1;
        ajaxObj({url: "excellent-report",method: "get",params:this.query})
        .then(response => {
            this.tableData = response.data.data;
            this.query.total = response.data.meta.total;
        })
     },


    
    // 添加入库  表单
    dialogCloseHandler() {
        this.$refs.userForm.clearValidate()
    },
    
    toAddHandler() {
      this.form = {}
      this.setTitle('添加入库信息')
      this.showModal()
    },
    setTitle(title) {
      this.title = title
    },
    closeModal() {
      this.visible = false
    },
    showModal() {
      this.visible = true
    },
    submitHandler(){
            // 表单验证
        // this.$refs.userForm.validate((valid) => {
        //     if (valid) {
        //     // 2 提交表单
        //         ajaxObj({url: "users/add-teacher",method: "post",
        //             data:this.form
        //         })
        //         .then((response) => {
        //             this.$message({ type: 'success', message: '添加成功' });
        //             this.reload()                                               
        //         })
        //     } else {
        //         this.$message({ type: 'error', message: '添加失败' })
        //     }
        // })
    },
    // 修改入库  表单
    dialogCloseHandler2() {
        this.$refs.userForm2.clearValidate()
    },
    setTitle2(title2) {
        this.title2 = title2
    },
    closeModal2() {
      this.visible2 = false
    },
    showModal2() {
      this.visible2 = true
    },
    submitHandler2(){
            // 表单验证
            // 2 提交表单
                ajaxObj({url: "excellent-report/audit",method: "post",
                    data:this.audit
                })
                .then((response) => {
                    this.$message({ type: 'success', message: '审批完成' });

                     ajaxObj({url: "excellent-report",method: "get",params:this.query})
                  .then(response => {
                      this.tableData = response.data.data;
                      this.query.total = response.data.meta.total;
                      this.closeModal2()
                  })
                    // this.reload()                                               
                })
            
    },
    //  删除入库
     deleteHandler(id){
        // if(id){
        //     ajaxObj({url: "users/delete",method: "post", data:{"id":id}})
        //     .then(response => {
        //         this.$message({ type: 'success', message: '删除成功'});
        //         this.reload()
        //     });
        // } else {
        //         this.$message({ type: 'error', message: '删除失败' })
        // }
        
     },
    //  修改入库
    approval(row){
      this.audit.id = row.id;
      this.audit.status = 'AGREE'
      this.setTitle2('审批')
      this.showModal2()
      // ajaxObj({url: "excellent-report/audit",method: "post",
      //         data:this.form2
      //     })
      //     .then((response) => {
      //         this.$message({ type: 'success', message: '修改成功' });
      //         this.reload()                                               
      //     })
      
     },
     
     // 初始页currentPage、初始每页数据数pagesize和数据data
    handleSizeChange: function(size) {
    this.pagesize = size
    console.log(this.pagesize) // 每页下拉显示数据
    },
    handleCurrentChange: function(page) {
    this.query.currentPage = page;
    this.query.page = page-1;
    this.currentPage = page
     ajaxObj({url: "excellent-report",method: "get",params:this.query})
        .then(response => {
            this.tableData = response.data.data;
            this.query.total = response.data.meta.total;
        })
    },

 },
 created(){
    this.findUserlist();
 }
}
</script>

<style scoped>
.page {
    width: 100%;
    height: 100%;
}
.head {
    padding: 20px;
    font-size: 20px;
    border-bottom: 1px solid #ccc;
    box-sizing:border-box;

}
.bar {
    height: 100px;
    box-sizing:border-box;
    padding: 20px;
    font-size: 18px;
    padding-left: 60px;
    display:flex;
    align-items:center;
}
.bartip {
    margin: 0 8px 0 8px;
}
.table {
    width:98%;
    margin:0 auto;
}
.el-pagination {
    text-align: right;
    box-sizing: border-box;
    padding-right: 100px;
    padding-top: 20px;
}
/* 预览实践报告 */
.sjbg_fg {
  width: 100%;
  border-bottom: 2px solid #000000;
}
.sjbg_bg {
  width: 100%;
  padding-top: 20px;
  padding-bottom: 20px;
  background-color: #EDEDF0;
}
.sjbg_table {
  width: 1000px;
  padding-bottom: 100px;
  margin: 0 auto;
  background-color: #FFFFFF;
  box-shadow:0px 0px 10px #69797E;
}
.sjbg_title {
  padding-top: 100px;
  width: 100%;
  text-align: center;
  font-size: 26px;
  font-weight: 600;
}
.sjbg_title ul > li {
  padding-bottom: 20px;
}
.sjbg {
  width: 70%;
  margin: 20px auto 0 auto;
  border: 2px solid;
}
.title {
  font-size: 18px;
  font-weight: bold;
  padding-left: 10px;
  height: 30px;
  line-height: 30px;
  border-bottom: 2px solid;
}
.first {
  display: table;
}
.table_cell_left {
  border-bottom: 2px solid #2d3e50;
  height: 60px;
  width: 500px;
  display: table-cell;
  vertical-align:middle;
  text-align: center;
}
.table_cell {
  border-left: 2px solid #2d3e50;
  border-bottom: 2px solid #2d3e50;
  height: 60px;
  width: 500px;
  display: table-cell;
  vertical-align:middle;
  text-align: center;
}
.title2 {
  font-size: 18px;
  font-weight: bold;
  padding-left: 10px;
  height: 30px;
  line-height: 30px;
}
.paragraph_table {
  padding-left: 10px;
  line-height: 24px;
}
.paragraph {
  padding-left: 10px;
  line-height: 24px;
  text-indent: 32px;
}
.paragraph_last {
  padding-left: 10px;
  line-height: 24px;
  padding-bottom: 10px;
  border-bottom: 2px solid #2d3e50;
}
.title3 {
  font-size: 18px;
  font-weight: bold;
  padding-left: 10px;
  height: 30px;
  line-height: 30px;
}
.paragraph_heading {
  text-align: center;
  font-weight: 600;
  padding: 20px 0;
}
.paragraph_title {
  padding:10px 0 10px 10px;
}
.paragraph_title2 {
  padding:10px 0 10px 50px;
}
.paragraph_heading2 {
  text-align: center;
  font-weight: 400;
  padding: 20px 0;
}
.second {
  width: 90%;
  margin: 0 auto;
}
.table_cell2 {
  border-left: 2px solid #2d3e50;
  border-top: 2px solid #2d3e50;
  height: 24px;
  width: 500px;
  display: table-cell;
  vertical-align:middle;
  text-align: center;
}
.table_cell2_right {
  border-left: 2px solid #2d3e50;
  border-top: 2px solid #2d3e50;
  border-right: 2px solid #2d3e50;
  height: 24px;
  width: 500px;
  display: table-cell;
  vertical-align:middle;
  text-align: center;
}
.third {
  padding-top: 10px;
  width: 90%;
  margin: 0 auto;
}
.table_cell3 {
  border-left: 2px solid #2d3e50;
  border-top: 2px solid #2d3e50;
  height: 44px;
  width: 500px;
  display: table-cell;
  vertical-align:middle;
  text-align: center;
}
.table_cell3_right {
  border-left: 2px solid #2d3e50;
  border-top: 2px solid #2d3e50;
  border-right: 2px solid #2d3e50;
  height: 44px;
  width: 500px;
  display: table-cell;
  vertical-align:middle;
  text-align: center;
}
.table_cell3_right2 {
  border-left: 2px solid #2d3e50;
  border-top: 2px solid #2d3e50;
  border-right: 2px solid #2d3e50;
  height: 44px;
  width: 500px;
  display: table-cell;
  vertical-align:middle;
  padding-left: 10px;
}
.fourth {
  width: 50%;
  margin: 0 auto;
}
.table_cell4 {
  border-left: 2px solid #2d3e50;
  border-top: 2px solid #2d3e50;
  height: 24px;
  width: 500px;
  display: table-cell;
  vertical-align:middle;
  text-align: center;
}
.table_cell4_right {
  border-left: 2px solid #2d3e50;
  border-top: 2px solid #2d3e50;
  border-right: 2px solid #2d3e50;
  height: 24px;
  width: 500px;
  display: table-cell;
  vertical-align:middle;
  text-align: center;
}
.table_cell4_right2 {
  border-left: 2px solid #2d3e50;
  border-top: 2px solid #2d3e50;
  border-right: 2px solid #2d3e50;
  height: 24px;
  width: 500px;
  display: table-cell;
  vertical-align:middle;
  text-align: center;
  padding-left: 10px;
}
.fifth {
  width: 80%;
  margin: 0 auto;
}
.table_cell5 {
  border-left: 2px solid #2d3e50;
  border-top: 2px solid #2d3e50;
  height: 30px;
  width: 500px;
  display: table-cell;
  vertical-align:middle;
  text-align: center;
}
.table_cell5_right {
  border-left: 2px solid #2d3e50;
  border-top: 2px solid #2d3e50;
  border-right: 2px solid #2d3e50;
  height: 30px;
  width: 500px;
  display: table-cell;
  vertical-align:middle;
  text-align: center;
}
.table_cell5_right2 {
  border-left: 2px solid #2d3e50;
  border-top: 2px solid #2d3e50;
  border-right: 2px solid #2d3e50;
  height: 30px;
  width: 500px;
  display: table-cell;
  vertical-align:middle;
  text-align: center;
  padding-left: 10px;
}
.el-drawer__header span {
  font-weight: bold !important;
}
.download {
  position: fixed;
  left: 150px;
  top: 20px;
}
.prompt1 {
  text-indent: 32px;
  line-height: 30px;
}
.prompt2 {
  text-indent: 32px;
  line-height: 30px;

}
/* 实践报告2 部分 */
.fourthb {
  width: 80%;
  margin: 0 auto;
}
.table_cell4b {
  border-left: 2px solid #2d3e50;
  border-top: 2px solid #2d3e50;
  height: 24px;
  width: 500px;
  display: table-cell;
  vertical-align:middle;
  text-align: center;
}
.table_cell4_rightb {
  border-left: 2px solid #2d3e50;
  border-top: 2px solid #2d3e50;
  height: 24px;
  width: 500px;
  display: table-cell;
  vertical-align:middle;
  text-align: center;
}
.table_cell4_right2b {
  border-left: 2px solid #2d3e50;
  border-top: 2px solid #2d3e50;
  border-right: 2px solid #2d3e50;
  height: 24px;
  width: 500px;
  display: table-cell;
  vertical-align:middle;
  text-align: center;
  padding-left: 10px;
}
/* 审批页 */
.shenpi_content {
  border: 1px solid #ccc;
}
.information {
  height: 50px;
  line-height: 50px;
  font-weight: 600;
}
.task {
  border-top: 1px solid #ccc;
  padding-left: 20px;
  height: 50px;
  line-height: 50px;
  font-size: 18px;
  background-color: #f9f9f9;
}
.task_pjbz {
  padding-left: 60px;
  padding-top: 10px;
  padding-bottom: 10px;
}
.task_pjbz li {
  height: 26px;
  line-height: 26px;
  font-size: 16px;
}
.task_pjbz li:before{
  content: "";
           width: 6px;
           height: 6px;
           display: inline-block;
           border-radius: 50%;
           background: #121212;
           vertical-align: middle;
           margin-right: 14px;
}
.task_content {
  border-top: 1px solid #ccc;
  padding: 10px;
}
.content_title {
  text-align: center;
  font-size: 16px;
  font-weight: 600;
}
.content_titleb {
  text-align: center;
  font-size: 16px;
}
.content_main {
  font-size: 16px;
  text-indent: 32px;
}
</style>



// WEBPACK FOOTER //
// src/views/report/treasuryApproval.vue